define(['lodash'], function (_) {
    'use strict';

    return function shouldShowHiddenComp(argsObj) {
        const ignoreHiddenProperty = _.includes(argsObj.renderFlags.ignoreComponentsHiddenProperty, argsObj.compId);
        const showHiddenComponents = argsObj.renderFlags.showHiddenComponents;
        const isHidden = _.get(argsObj.compProperties, 'isHidden');
        return !isHidden || ignoreHiddenProperty || isHidden && showHiddenComponents; // eslint-disable-line no-mixed-operators
    };
});
